module.exports = __webpack_public_path__ + "img/wlv_19.ba012caf.png";